import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const mealVouchersRoutesDictionary = moduleRouteDictionaryFactory(
  'mealVouchers',
  'mealVouchers',
  {
    cardOrdersList: 'card-orders',
    createCardOrder: 'card-orders/create',
    cardOrderDetail: 'card-orders/:orderId',
    ordersList: 'orders',
    createOrder: 'orders/create',
    importOrder: 'orders/import',
    orderDetail: 'orders/:id',
  },
);
